import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=ce659378&scoped=true"
import script from "./comment.vue?vue&type=script&lang=ts"
export * from "./comment.vue?vue&type=script&lang=ts"
import style0 from "./comment.vue?vue&type=style&index=0&id=ce659378&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce659378",
  null
  
)

export default component.exports